import React from 'react';
import { TableRow, TableCell, Link } from '@mui/material';

// UTILS
import { getZoneOffsettedDate } from '../../../utils/dates';

// STYLES
import { tableFilterOption } from '../../../styles/filters';

const AllMessagesTableRow = ({
  id,
  date = '',
  user = '',
  from = '',
  to = '',
  country = '',
  status = '',
  errorCode = '',
  parameters = '',
  duration = '',
  onClickMessage = null,
  clickToFilter = null,
  sentSms = null,
}) => {
  const rezonedDate = getZoneOffsettedDate(date);

  return (
    <TableRow key={`list${id}`} id={id}>
      <TableCell name="date">
        <Link tabIndex={1} onClick={() => onClickMessage(sentSms)}>
          {rezonedDate}
        </Link>
      </TableCell>
      <TableCell
        name="user"
        onClick={() => clickToFilter('userFilter', user)}
        sx={tableFilterOption}
      >
        {user}
      </TableCell>
      <TableCell
        name="from"
        onClick={() => clickToFilter('fromFilter', from)}
        sx={tableFilterOption}
      >
        {from}
      </TableCell>
      <TableCell
        name="to"
        onClick={() => clickToFilter('toFilter', to)}
        sx={tableFilterOption}
      >
        {to}
      </TableCell>
      <TableCell name="country">{country}</TableCell>
      <TableCell
        name="status"
        onClick={() => clickToFilter('statusFilter', status)}
        sx={tableFilterOption}
      >
        {status}
      </TableCell>
      <TableCell
        name="errorCode"
        onClick={() => clickToFilter('errorFilter', errorCode)}
        sx={tableFilterOption}
      >
        {errorCode}
      </TableCell>
      <TableCell name="parameters">{parameters}</TableCell>
      <TableCell name="duration">{duration}</TableCell>
    </TableRow>
  );
};

export default AllMessagesTableRow;
